import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  paymentTerms: [],
  isLoading: false
})

const getters = {
  paymentTerms: (state) => state.paymentTerms,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_PAYMENT_TERMS(state, payload) {
    state.paymentTerms = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchPaymentTerms({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get('/api/dashboard/payment_terms')
      .then((res) => {
        commit('SET_PAYMENT_TERMS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createPaymentTerm({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/payment_terms`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/payment-terms')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deletePaymentTerm(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/payment_terms/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchPaymentTerm(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/payment_terms/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.nameEn = message.name_en
        vm.editForm.nameRu = message.name_ru
        vm.editForm.active = message.active === 'yes'
        vm.logoUrl = message.logo
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updatePaymentTerm(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/payment_terms/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editPaymentTermModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
